import {
  varRSVPDataColor1,
  varRSVPDataColor2,
  varRSVPDataColor3,
  varRSVPDataColor4,
  varRSVPDataColor5,
} from '../../helpers/chartColors';
import React from 'react';
import {
  useEventQuestionResponseQuery,
  useEventRsvpDataQuery,
  useEventsQuery,
  useGuestWeddingQuestionResponseQuery,
  useWeddingWebsiteQuery,
} from '../../generated/graphql';
import EventQuestionCards from './EventQuestionCards';
import GeneralQuestionCards from './GeneralQuestionCards';
import styles from './rsvpSummaryCard.scss';

const RsvpSummaryCard: React.FC = () => {
  const { data: gdsData } = useWeddingWebsiteQuery();
  const { data: eventQuestionsData } = useEventQuestionResponseQuery();
  const { data: guestWeddingQuestionData } = useGuestWeddingQuestionResponseQuery();
  const { data: rsvpData } = useEventRsvpDataQuery();
  const { data: eventData } = useEventsQuery();
  const isPrivateRsvp = Boolean(gdsData?.guestWedding?.isPrivateRsvp);

  const dataColors = [varRSVPDataColor1, varRSVPDataColor2, varRSVPDataColor3, varRSVPDataColor4, varRSVPDataColor5];

  return (
    <div className={styles.rsvpSummaryCardContainer}>
      {/* Event Questions */}
      <EventQuestionCards
        eventData={eventData}
        eventQuestionsData={eventQuestionsData}
        rsvpData={rsvpData}
        isPrivateRsvp={isPrivateRsvp}
        dataColors={dataColors}
      />
      {/* General Questions */}
      {!!guestWeddingQuestionData?.guestWeddingQuestionResponseData.questionsData?.length && (
        <GeneralQuestionCards guestWeddingQuestionData={guestWeddingQuestionData} dataColors={dataColors} />
      )}
    </div>
  );
};
export default RsvpSummaryCard;
